import React from 'react';
import styled from 'styled-components';
import { Card, CardStrip, CardStateSection } from '../Card/Card';
import CheckmarkIcon from '../../assets/icons/checkmark.svg?react';

export type SuccessCardProps = {
  /**
   * Children of the component
   */
  children: React.ReactNode;
  /**
   * Width of the card
   */
  desktopWidth?: string;
};

const SuccessStateSection = styled(CardStateSection)`
  background: var(--green-50);
`;

const SuccessContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const CircularCheckmarkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--green-400);
  color: var(--white);
`;

/**
 * A success card component that displays content with a green success indicator and checkmark icon.
 */
export const SuccessCard = ({ children, desktopWidth }: SuccessCardProps) => {
  return (
    <Card desktopWidth={desktopWidth}>
      <CardStrip $backgroundColor="var(--green-400)" />
      <SuccessContentContainer>
        <SuccessStateSection>
          <CircularCheckmarkContainer>
            <CheckmarkIcon width={8} height={8} />
          </CircularCheckmarkContainer>
        </SuccessStateSection>
        {children}
      </SuccessContentContainer>
    </Card>
  );
};

export default SuccessCard;
